module.exports = "<li class=\"global-navigation__section js-global-navigation__section--history\" data-link-name=\"shortcuts\">\n    <span class=\"global-navigation__title global-navigation__title--history\">recently visited</span>\n    <ul class=\"global-navigation__children global-navigation__children--history\">\n        <%=tags%>\n        <a class=\"button button--small button--tag button--tertiary\" href=\"/preferences\" data-link-name=\"edit\">edit these</a>\n    </ul>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/common/views/history/mega-nav.html
// module id = 313
// module chunks = 0 17